module.exports = __webpack_public_path__ + "img/pe.843ae62c.svg";